import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { colors, ApMenu } from '@alixpartners/ui-components';

export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	overflow: hidden !important;
	display: flex;
	flex-direction: column;
	height: 100%;
	max-height: 400px !important;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: 100%;
`;

export const DropdownLabel = styled.button`
	max-width: 100%;
	width: 100%;
	height: 28px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-left: 8px;
	background-color: ${colors.white};
	outline: none;
	border: 1px solid ${colors.grey3};
	cursor: pointer;

	&:hover {
		background-color: ${rgba(colors.green2, 0.1)};
	}

	&:focus {
		background-color: ${rgba(colors.green2, 0.2)};
	}

	&:active {
		background-color: ${rgba(colors.green2, 0.3)};
		border: 1px solid ${colors.green3};
	}

	${({ isOpen }) =>
		isOpen
			? css`
					border: 1px solid ${colors.green3};

					svg:last-child {
						transform: rotate(180deg);
					}
			  `
			: ''};
`;

export const LabelText = styled.span`
	letter-spacing: 0.3px;
	font-weight: 400;
	font-size: 13px;
	color: ${({ disabled }) => (disabled ? `${colors.grey5}` : 'black')};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const IconWrapper = styled.div`
	height: 100%;
`;
